 /* eslint-disable no-unused-vars */
// import { useEffect, useState } from 'react';
// import { Box, HStack, Menu, MenuButton, MenuList, StackDivider, Text } from '@chakra-ui/react';
// import { MenuItem } from 'react-pro-sidebar';
// import { useSelector, useDispatch } from 'react-redux';
// import { cartIcon, notification } from './Icons';
// import { useNavigate } from 'react-router-dom';
// import { view_cart } from '../../../redux/actions/productActions';
// import ProfileMenu from './ProfileMenu';
// import useGetUserDetails from 'hooks/useGetUserDetail';
// import DashCurrencySelector from './currency-selector';


// const DashHead = () => {
//     const [bg, setBg] = useState(true);
//     const navigate = useNavigate();
//     const dispatch = useDispatch();

//     const productReducer = useSelector((state) => state.productReducer);
//     const { cartItems, quoteId, cart } = productReducer;

//     const { flattenedUser: details } = useGetUserDetails();

//     useEffect(() => {
//         if (quoteId) {
//             dispatch(view_cart());
//         }
//     }, [dispatch, cart, quoteId]);

//     return (
//         <Box width={'full'}>
//             <HStack justify="end" w="full" mb="4">
//                 <HStack divider={<StackDivider borderColor="gray.200" />}>
//                     <DashCurrencySelector />

//                     <Menu>
//                         <MenuButton px={4}>{notification}</MenuButton>
//                         <MenuList listStyleType="none">
//                             <MenuItem>New File</MenuItem>
//                             <MenuItem>New Window</MenuItem>
//                         </MenuList>
//                     </Menu>

//                     <div
//                         onClick={() => navigate('/dashboard/cart', { replace: true })}
//                         style={{
//                             cursor: 'pointer',
//                             display: 'flex',
//                             position: 'relative',
//                             width: 30,
//                         }}>
//                         {cartIcon}
//                         <span
//                             style={{
//                                 background: '#0B59D5',
//                                 width: 16,
//                                 height: 16,
//                                 alignItems: 'center',
//                                 justifyContent: 'center',
//                                 display: 'flex',
//                                 borderRadius: 20,
//                                 fontSize: 12,
//                                 color: '#fff',
//                                 position: 'absolute',
//                                 right: 0,
//                                 top: -5,
//                                 zIndex: 1000,
//                             }}>
//                             {cartItems ? cartItems?.items?.length : 0}
//                         </span>
//                     </div>

//                     <ProfileMenu setBg={setBg} bg={bg} bgImg={details?.attributes?.user_imgage} />
//                 </HStack>

//                 <Text>
//                     {details?.attributes?.first_name
//                         ? `${details?.attributes?.first_name} ${details?.attributes?.last_name}`
//                         : `${details?.agent_id}`}
//                 </Text>
//             </HStack>
//         </Box>
//     );
// };

// export default DashHead;

import { useEffect, useState, useCallback, useMemo, memo, useRef } from 'react';
import {
    Box,
    Flex,
    HStack,
    Input,
    InputGroup,
    InputLeftElement,
    IconButton,
    Image,
    Menu,
    MenuButton,
    MenuList,
    Text,
    Badge,
    Skeleton,
    useBreakpointValue,
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    VStack,
} from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { view_cart, get_all_products } from '../../../redux/actions/productActions';
import ProfileMenu from './ProfileMenu';
import useGetUserDetails from 'hooks/useGetUserDetail';
import DashCurrencySelector from './currency-selector';
import SearchFilterInput from 'components/Dashboard/SearchFilterInput';
import useDebounce from 'hooks/useDebounce';
import { ITEMS_PER_PAGE } from 'utils/utils';

/* ─────────────────────────────────────────────────────────────
   BRAND TOKENS
   ───────────────────────────────────────────────────────────── */

const NAVY        = '#1B3B5F';
const NAVY_DEEP   = '#0F2940';
const CYAN        = '#DCF8F9';
const INK         = '#1A2740';
const MUTED       = '#5A6B7E';
const FAINT       = '#8896AE';
const SURFACE     = '#FFFFFF';
const SURFACE_ALT = '#F7F9FB';
const BORDER      = '#E8EDF5';
const DANGER      = '#E53E3E';

const SHADOW_SM = '0 1px 3px rgba(27,59,95,0.06)';
const SHADOW_MD = '0 4px 16px rgba(27,59,95,0.08)';
const SHADOW_LG = '0 12px 32px rgba(27,59,95,0.12)';

const FONT = "'Bricolage Grotesque', sans-serif";

const HEADER_HEIGHT = '64px';

/* Tunables */
const SEARCH_DEBOUNCE_MS  = 700;          // matches Products page
const SEARCH_PREVIEW_SIZE = 6;            // max results in dropdown

/* Stable Redux query — prevents the search trigger from blowing away
   the products page's own paginated state once we navigate. We use a
   small preview payload to keep the request cheap. */
const buildSearchQuery = (term) => ({
    per_page: SEARCH_PREVIEW_SIZE,
    page:     1,
    name:     term,
});

/* ─────────────────────────────────────────────────────────────
   ICONS
   ───────────────────────────────────────────────────────────── */

const SearchIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...props}>
        <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
        <path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const BellIcon = (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M18 16v-5a6 6 0 10-12 0v5l-1.5 2h15L18 16z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M10 21a2 2 0 004 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);

const CartIcon = (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M3 4h2l2.4 12.2a2 2 0 002 1.8h8.7a2 2 0 002-1.6L22 8H6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="10" cy="21" r="1.5" fill="currentColor" />
        <circle cx="18" cy="21" r="1.5" fill="currentColor" />
    </svg>
);

const CommandIcon = (props) => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M9 6V18M15 6V18M6 9H18M6 15H18M9 6a3 3 0 11-3 3 M15 6a3 3 0 113 3 M9 18a3 3 0 11-3-3 M15 18a3 3 0 113-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

const InboxIcon = (props) => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M22 12h-6l-2 3h-4l-2-3H2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.5 5h13l3 7v6a2 2 0 01-2 2h-15a2 2 0 01-2-2v-6l3-7z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
);

const CloseIcon = (props) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const ArrowRightIcon = (props) => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M5 12h14M13 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

/* ─────────────────────────────────────────────────────────────
   HEADER ICON BUTTON
   ───────────────────────────────────────────────────────────── */

const HeaderIconButton = memo(function HeaderIconButton({
    ariaLabel, icon, onClick, badgeContent, badgeColor = NAVY, ...rest
}) {
    return (
        <Box position="relative" flexShrink={0}>
            <IconButton
                aria-label={ariaLabel}
                onClick={onClick}
                icon={icon}
                variant="ghost"
                size="md"
                color={MUTED}
                borderRadius="10px"
                h="40px"
                w="40px"
                _hover={{ bg: CYAN, color: NAVY }}
                _active={{ bg: CYAN }}
                {...rest}
            />
            {badgeContent != null && Number(badgeContent) > 0 && (
                <Badge
                    position="absolute"
                    top="2px"
                    right="2px"
                    minW="18px"
                    h="18px"
                    px="4px"
                    bg={badgeColor}
                    color="white"
                    fontSize="10px"
                    fontWeight="700"
                    borderRadius="full"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    border="2px solid"
                    borderColor={SURFACE}
                    pointerEvents="none"
                >
                    {Number(badgeContent) > 99 ? '99+' : badgeContent}
                </Badge>
            )}
        </Box>
    );
});

/* ─────────────────────────────────────────────────────────────
   NOTIFICATIONS
   ───────────────────────────────────────────────────────────── */

const useNotifications = () => ({
    notifications: [],
    unreadCount:   0,
    isLoading:     false,
    markAllRead:   () => {},
});

const NotificationItem = memo(function NotificationItem({ notification }) {
    return (
        <Flex p="12px 16px" gap="12px" align="flex-start" cursor="pointer"
            _hover={{ bg: SURFACE_ALT }} borderBottom="1px solid" borderColor={BORDER}
            transition="background 0.15s ease">
            <Box w="8px" h="8px" borderRadius="full" bg={notification.read ? 'transparent' : NAVY}
                mt="6px" flexShrink={0} />
            <Box flex="1" minW="0">
                <Text fontSize="13px" fontWeight={notification.read ? '500' : '700'} color={INK} mb="2px">
                    {notification.title}
                </Text>
                <Text fontSize="11px" color={FAINT} noOfLines={2}>{notification.message}</Text>
                <Text fontSize="10px" color={FAINT} mt="4px">{notification.timeAgo}</Text>
            </Box>
        </Flex>
    );
});

const NotificationsMenu = memo(function NotificationsMenu({ navigate }) {
    const { notifications, unreadCount, isLoading, markAllRead } = useNotifications();

    return (
        <Menu placement="bottom-end" autoSelect={false}>
            <MenuButton as={Box} aria-label="Notifications" cursor="pointer">
                <HeaderIconButton
                    ariaLabel="Notifications"
                    icon={<BellIcon />}
                    badgeContent={unreadCount}
                    badgeColor={DANGER}
                    as="div"
                    pointerEvents="none"
                />
            </MenuButton>
            <MenuList p="0" minW="360px" maxW="380px" borderRadius="16px" border="1px solid"
                borderColor={BORDER} boxShadow={SHADOW_MD} overflow="hidden" fontFamily={FONT}>
                <Flex p="14px 16px" justify="space-between" align="center"
                    borderBottom="1px solid" borderColor={BORDER} bg={SURFACE_ALT}>
                    <Text fontSize="13px" fontWeight="800" color={INK}>Notifications</Text>
                    {unreadCount > 0 && (
                        <Text fontSize="11px" color={NAVY} fontWeight="600" cursor="pointer"
                            _hover={{ textDecoration: 'underline' }} onClick={markAllRead}>
                            Mark all read
                        </Text>
                    )}
                </Flex>
                <Box maxH="400px" overflowY="auto">
                    {isLoading ? (
                        <Flex justify="center" p="40px">
                            <Text fontSize="12px" color={FAINT}>Loading…</Text>
                        </Flex>
                    ) : notifications.length === 0 ? (
                        <VStack p="40px 20px" spacing="10px">
                            <Box color={FAINT}><InboxIcon /></Box>
                            <Text fontSize="13px" fontWeight="700" color={INK}>You're all caught up</Text>
                            <Text fontSize="11px" color={FAINT} textAlign="center" maxW="220px">
                                New orders, shipments, and announcements will appear here.
                            </Text>
                        </VStack>
                    ) : (
                        notifications.map((n) => <NotificationItem key={n.id} notification={n} />)
                    )}
                </Box>
                {notifications.length > 0 && (
                    <Box p="10px 16px" borderTop="1px solid" borderColor={BORDER}
                        textAlign="center" cursor="pointer" _hover={{ bg: SURFACE_ALT }}
                        onClick={() => navigate('/dashboard/notifications')}>
                        <Text fontSize="12px" fontWeight="700" color={NAVY}>
                            View all notifications
                        </Text>
                    </Box>
                )}
            </MenuList>
        </Menu>
    );
});

/* ─────────────────────────────────────────────────────────────
   SEARCH PREVIEW DROPDOWN
   ───────────────────────────────────────────────────────────── */

const formatPrice = (item) => {
    /* Try to read common Zoho/inventory item price fields without
       crashing if absent. Fallback: empty string. */
    const raw =
        item?.rate ??
        item?.price ??
        item?.selling_price ??
        item?.cf_obana_price ??
        null;
    if (raw == null) return '';
    const n = Number(raw);
    if (!Number.isFinite(n)) return '';
    return `₦${n.toLocaleString()}`;
};

const SearchPreviewItem = memo(function SearchPreviewItem({ item, onClick, isActive }) {
    const image =
        item?.image_url ??
        item?.image ??
        item?.image_name ??
        null;
    const name = item?.name ?? item?.item_name ?? 'Unnamed product';
    const sku  = item?.sku ?? item?.item_id ?? '';
    const price = formatPrice(item);

    return (
        <Flex
            as="button"
            type="button"
            onClick={() => onClick?.(item)}
            align="center"
            gap="12px"
            w="full"
            p="10px 12px"
            bg={isActive ? SURFACE_ALT : 'transparent'}
            _hover={{ bg: SURFACE_ALT }}
            transition="background 0.12s ease"
            borderBottom="1px solid"
            borderColor={BORDER}
            textAlign="left"
            cursor="pointer"
        >
            <Box
                w="40px"
                h="40px"
                borderRadius="8px"
                bg={SURFACE_ALT}
                border="1px solid"
                borderColor={BORDER}
                flexShrink={0}
                overflow="hidden"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                {image ? (
                    <Image
                        src={image}
                        alt=""
                        w="full"
                        h="full"
                        objectFit="cover"
                        loading="lazy"
                    />
                ) : (
                    <Box color={FAINT}><SearchIcon /></Box>
                )}
            </Box>
            <Box flex="1" minW="0">
                <Text fontSize="13px" fontWeight="600" color={INK} noOfLines={1} fontFamily={FONT}>
                    {name}
                </Text>
                {(sku || price) && (
                    <Flex gap="8px" mt="2px" align="center">
                        {price && (
                            <Text fontSize="11px" color={NAVY} fontWeight="700">
                                {price}
                            </Text>
                        )}
                        {sku && (
                            <Text fontSize="10px" color={FAINT} noOfLines={1}>
                                {sku}
                            </Text>
                        )}
                    </Flex>
                )}
            </Box>
        </Flex>
    );
});

const SearchPreviewSkeleton = memo(function SearchPreviewSkeleton() {
    return (
        <Flex align="center" gap="12px" p="10px 12px" borderBottom="1px solid" borderColor={BORDER}>
            <Skeleton w="40px" h="40px" borderRadius="8px" startColor={SURFACE_ALT} endColor={BORDER} />
            <Box flex="1">
                <Skeleton h="3" w="80%" borderRadius="3px" mb="1.5" startColor={SURFACE_ALT} endColor={BORDER} />
                <Skeleton h="2.5" w="40%" borderRadius="3px" startColor={SURFACE_ALT} endColor={BORDER} />
            </Box>
        </Flex>
    );
});

const SearchPreviewDropdown = memo(function SearchPreviewDropdown({
    query, items, isLoading, onItemClick, onSeeAll, onClose,
}) {
    const hasResults = items?.length > 0;

    return (
        <Box
            position="absolute"
            top="calc(100% + 8px)"
            left="0"
            right="0"
            bg={SURFACE}
            border="1px solid"
            borderColor={BORDER}
            borderRadius="14px"
            boxShadow={SHADOW_LG}
            overflow="hidden"
            zIndex={20}
            fontFamily={FONT}
            maxH="480px"
            display="flex"
            flexDirection="column"
        >
            {/* Header */}
            <Flex
                p="10px 14px"
                justify="space-between"
                align="center"
                borderBottom="1px solid"
                borderColor={BORDER}
                bg={SURFACE_ALT}
                flexShrink={0}
            >
                <Text fontSize="10px" color={FAINT} fontWeight="700" letterSpacing="0.1em">
                    {isLoading ? 'SEARCHING…' : hasResults ? 'TOP RESULTS' : 'NO MATCHES'}
                </Text>
                <IconButton
                    aria-label="Close search results"
                    icon={<CloseIcon />}
                    onClick={onClose}
                    variant="ghost"
                    size="xs"
                    h="24px"
                    minW="24px"
                    color={FAINT}
                    _hover={{ color: INK, bg: SURFACE }}
                />
            </Flex>

            {/* Body */}
            <Box flex="1" overflowY="auto">
                {isLoading ? (
                    <>
                        {Array.from({ length: 3 }).map((_, i) => <SearchPreviewSkeleton key={i} />)}
                    </>
                ) : !hasResults ? (
                    <Flex direction="column" align="center" justify="center" p="32px 20px" gap="8px">
                        <Box color={FAINT}><InboxIcon /></Box>
                        <Text fontSize="13px" fontWeight="700" color={INK}>
                            No products found
                        </Text>
                        <Text fontSize="11px" color={FAINT} textAlign="center" maxW="240px">
                            Try a different keyword, or browse all products.
                        </Text>
                    </Flex>
                ) : (
                    items.slice(0, SEARCH_PREVIEW_SIZE).map((item, i) => (
                        <SearchPreviewItem
                            key={item.item_id ?? i}
                            item={item}
                            onClick={onItemClick}
                            isActive={false}
                        />
                    ))
                )}
            </Box>

            {/* Footer — "See all" */}
            <Flex
                as="button"
                type="button"
                onClick={onSeeAll}
                p="12px 16px"
                justify="space-between"
                align="center"
                borderTop="1px solid"
                borderColor={BORDER}
                bg={SURFACE}
                cursor="pointer"
                _hover={{ bg: SURFACE_ALT }}
                transition="background 0.15s ease"
                flexShrink={0}
            >
                <Text fontSize="12px" color={NAVY} fontWeight="700">
                    {hasResults
                        ? `See all results for "${query}"`
                        : `Search "${query}" anyway`}
                </Text>
                <Box color={NAVY}><ArrowRightIcon /></Box>
            </Flex>
        </Box>
    );
});

/* ─────────────────────────────────────────────────────────────
   SEARCH BAR (desktop) — wraps SearchFilterInput so it looks &
   behaves identically to the Products page
   ───────────────────────────────────────────────────────────── */

const SearchBar = memo(function SearchBar({ value, onChange, onFocus }) {
    /* SearchFilterInput calls onSearch with the typed string.
       We bubble that up to the parent via onChange. */
    const handleSearch = useCallback(
        (val) => {
            onChange(val ?? '');
        },
        [onChange]
    );

    return (
        <Box
            w="full"
            maxW="480px"
            onFocus={onFocus}
            sx={{
                /* Ensure the wrapper plays nicely with header height */
                '& input': { fontSize: '13px' },
            }}
        >
            <SearchFilterInput
                source="products, brands, categories"
                onSearch={handleSearch}
                value={value}
            />
        </Box>
    );
});
/* ─────────────────────────────────────────────────────────────
   MOBILE SEARCH MODAL — same debounced behavior
   ───────────────────────────────────────────────────────────── */

const MobileSearchModal = memo(function MobileSearchModal({
    isOpen, onClose, value, onChange, onSubmit, items, isLoading, onItemClick, onSeeAll,
}) {
    const inputRef = useRef(null);

    const handleSubmit = useCallback(
        (e) => {
            e.preventDefault();
            const v = (value ?? '').trim();
            if (!v) return;
            onSubmit(v);
        },
        [value, onSubmit]
    );

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="full" motionPreset="slideInTop"
            initialFocusRef={inputRef}>
            <ModalOverlay bg="blackAlpha.600" />
            <ModalContent borderRadius="0" m="0" maxH="100vh" bg={SURFACE}>
                <ModalBody p="0" display="flex" flexDirection="column">
                    {/* Search input bar */}
                    <Box p="16px" borderBottom="1px solid" borderColor={BORDER}>
                        <form onSubmit={handleSubmit}>
                            <Flex align="center" gap="12px">
                                <InputGroup flex="1">
                                    <InputLeftElement pointerEvents="none" h="44px">
                                        <Box color={FAINT}><SearchIcon /></Box>
                                    </InputLeftElement>
                                    <Input
                                        ref={inputRef}
                                        type="search"
                                        placeholder="Search products, brands…"
                                        value={value}
                                        onChange={(e) => onChange(e.target.value)}
                                        bg={SURFACE_ALT}
                                        border="1px solid"
                                        borderColor={BORDER}
                                        h="44px"
                                        pl="44px"
                                        fontSize="16px" /* 16px prevents iOS auto-zoom */
                                        borderRadius="12px"
                                        _focus={{ borderColor: NAVY, bg: SURFACE }}
                                        fontFamily={FONT}
                                        autoComplete="off"
                                    />
                                </InputGroup>
                                <Text
                                    as="button"
                                    type="button"
                                    fontSize="14px"
                                    fontWeight="600"
                                    color={NAVY}
                                    onClick={onClose}
                                    px="8px"
                                >
                                    Cancel
                                </Text>
                            </Flex>
                        </form>
                    </Box>

                    {/* Results */}
                    <Box flex="1" overflowY="auto" fontFamily={FONT}>
                        {!value.trim() ? (
                            <Flex direction="column" align="center" justify="center" p="60px 20px" gap="10px">
                                <Box color={FAINT}><SearchIcon /></Box>
                                <Text fontSize="13px" color={FAINT} textAlign="center">
                                    Type to search products
                                </Text>
                            </Flex>
                        ) : isLoading ? (
                            <>
                                {Array.from({ length: 5 }).map((_, i) => <SearchPreviewSkeleton key={i} />)}
                            </>
                        ) : items.length === 0 ? (
                            <Flex direction="column" align="center" justify="center" p="40px 20px" gap="10px">
                                <Box color={FAINT}><InboxIcon /></Box>
                                <Text fontSize="13px" fontWeight="700" color={INK}>
                                    No products found
                                </Text>
                                <Text fontSize="11px" color={FAINT} textAlign="center" maxW="240px">
                                    Try a different keyword, or browse all products.
                                </Text>
                            </Flex>
                        ) : (
                            <>
                                <Box p="10px 16px 4px" bg={SURFACE_ALT}>
                                    <Text fontSize="10px" color={FAINT} fontWeight="700" letterSpacing="0.1em">
                                        TOP RESULTS
                                    </Text>
                                </Box>
                                {items.slice(0, SEARCH_PREVIEW_SIZE).map((item, i) => (
                                    <SearchPreviewItem
                                        key={item.item_id ?? i}
                                        item={item}
                                        onClick={onItemClick}
                                    />
                                ))}
                                <Flex
                                    as="button"
                                    type="button"
                                    onClick={onSeeAll}
                                    p="14px 16px"
                                    justify="space-between"
                                    align="center"
                                    borderTop="1px solid"
                                    borderColor={BORDER}
                                    cursor="pointer"
                                    _hover={{ bg: SURFACE_ALT }}
                                    w="full"
                                >
                                    <Text fontSize="13px" color={NAVY} fontWeight="700">
                                        See all results for "{value.trim()}"
                                    </Text>
                                    <Box color={NAVY}><ArrowRightIcon /></Box>
                                </Flex>
                            </>
                        )}
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
});

/* ─────────────────────────────────────────────────────────────
   USER BADGE
   ───────────────────────────────────────────────────────────── */

const UserBadge = memo(function UserBadge({ name, avatarUrl, agentId, setBg, bg }) {
    return (
        <Flex align="center" gap="10px" flexShrink={0}>
            <Box display={{ base: 'none', md: 'block' }} textAlign="right" minW="0">
                <Text fontSize="13px" fontWeight="700" color={INK} lineHeight="1.2"
                    noOfLines={1} fontFamily={FONT}>
                    {name}
                </Text>
                {agentId && (
                    <Text fontSize="10px" color={FAINT} fontWeight="500" lineHeight="1.2" noOfLines={1}>
                        Agent · {agentId}
                    </Text>
                )}
            </Box>
            <ProfileMenu setBg={setBg} bg={bg} bgImg={avatarUrl} />
        </Flex>
    );
});

/* ─────────────────────────────────────────────────────────────
   SCROLL-DIRECTION HOOK
   ───────────────────────────────────────────────────────────── */

const DEBUG = false;

const useScrollDirection = ({
    threshold      = 8,
    topOffset      = 80,
    scrollSelector = null,
} = {}) => {
    const [hidden, setHidden] = useState(false);
    const lastScrollY = useRef(0);
    const ticking     = useRef(false);

    useEffect(() => {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced) return;

        const findScroller = () => {
            const candidates = [];
            if (scrollSelector) {
                const el = document.querySelector(scrollSelector);
                if (el) candidates.push(el);
            }
            ['main', '[role="main"]', '.chakra-container'].forEach((sel) => {
                document.querySelectorAll(sel).forEach((el) => candidates.push(el));
            });
            for (const el of candidates) {
                const style = window.getComputedStyle(el);
                const overflowY = style.overflowY;
                if ((overflowY === 'auto' || overflowY === 'scroll') &&
                    el.scrollHeight > el.clientHeight) {
                    return el;
                }
            }
            if (scrollSelector) {
                const seed = document.querySelector(scrollSelector);
                let node = seed?.parentElement;
                while (node && node !== document.body) {
                    const style = window.getComputedStyle(node);
                    if ((style.overflowY === 'auto' || style.overflowY === 'scroll') &&
                        node.scrollHeight > node.clientHeight) {
                        return node;
                    }
                    node = node.parentElement;
                }
            }
            return null;
        };

        const target = findScroller();
        const getScrollY = () =>
            target ? target.scrollTop :
            (window.scrollY || window.pageYOffset || document.documentElement.scrollTop);

        const onScroll = () => {
            if (ticking.current) return;
            ticking.current = true;
            requestAnimationFrame(() => {
                const currentY = getScrollY();
                const delta = currentY - lastScrollY.current;
                if (Math.abs(delta) >= threshold) {
                    if (currentY < topOffset) setHidden(false);
                    else if (delta > 0)        setHidden(true);
                    else                       setHidden(false);
                    lastScrollY.current = currentY;
                }
                ticking.current = false;
            });
        };

        const listener = target ?? window;
        listener.addEventListener('scroll', onScroll, { passive: true });
        return () => listener.removeEventListener('scroll', onScroll);
    }, [threshold, topOffset, scrollSelector]);

    return hidden;
};

/* ─────────────────────────────────────────────────────────────
   MAIN
   ───────────────────────────────────────────────────────────── */

const DashHead = () => {
    const [bg, setBg]               = useState(true);
    const [searchValue, setSearchValue] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const debouncedQuery = useDebounce(searchValue, SEARCH_DEBOUNCE_MS);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const containerRef = useRef(null);

    const productReducer = useSelector((state) => state.productReducer);
    const { cartItems, quoteId, cart, products, loading: productsLoading } = productReducer;

    const { flattenedUser: details } = useGetUserDetails();
    const mobileSearch = useDisclosure();
    const isMobile = useBreakpointValue({ base: true, md: false });

    const hideHeader = useScrollDirection({
        threshold:      8,
        topOffset:      80,
        scrollSelector: '[data-dash-scroll]',
    });

    /* ── Derived values ─────────────────────────────────────── */

    const cartCount = useMemo(() => cartItems?.items?.length ?? 0, [cartItems]);

    const displayName = useMemo(() => {
        const first = details?.attributes?.first_name;
        const last  = details?.attributes?.last_name;
        if (first || last) return [first, last].filter(Boolean).join(' ');
        return 'Welcome';
    }, [details]);

    const agentId = details?.agent_id ?? details?.attributes?.agent_id ?? null;
    const avatar  = details?.attributes?.user_imgage ?? details?.attributes?.user_image ?? null;

    const previewItems = useMemo(
        () => (products?.items ?? []).slice(0, SEARCH_PREVIEW_SIZE),
        [products]
    );

    const trimmedDebounced = useMemo(() => debouncedQuery.trim(), [debouncedQuery]);

    /* ── Effects ────────────────────────────────────────────── */

    /* Refetch cart when quote changes */
    useEffect(() => {
        if (quoteId) dispatch(view_cart());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, cart, quoteId]);

    /* Cmd+K shortcut — focuses the search input (handles both header & mobile) */
    useEffect(() => {
        const onKey = (e) => {
            if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
                e.preventDefault();
                if (isMobile) {
                    mobileSearch.onOpen();
                } else {
                    // SearchFilterInput renders a standard input; focus the first one in the header
                    const headerInput = document.querySelector('header input[type="text"], header input[type="search"]');
                    headerInput?.focus();
                }
            }
            if (e.key === 'Escape') {
                setIsDropdownOpen(false);
            }
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [isMobile, mobileSearch]);

    /* Dispatch debounced search — mirrors Products page */
    useEffect(() => {
        if (!trimmedDebounced) return;
        dispatch(get_all_products(buildSearchQuery(trimmedDebounced)));
    }, [trimmedDebounced, dispatch]);

    /* Close dropdown when clicking outside */
    useEffect(() => {
        if (!isDropdownOpen) return;
        const onDocClick = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, [isDropdownOpen]);

    /* ── Handlers ───────────────────────────────────────────── */

    const handleSearchChange = useCallback((v) => {
        setSearchValue(v);
        if (v.trim().length > 0) setIsDropdownOpen(true);
        else                     setIsDropdownOpen(false);
    }, []);

    const handleSearchFocus = useCallback(() => {
        if (searchValue.trim().length > 0) setIsDropdownOpen(true);
    }, [searchValue]);

   
const handleProductClick = useCallback(
    (item) => {
        const itemId = item?.item_id ?? item?.id;
        setIsDropdownOpen(false);
        mobileSearch.onClose();
        if (itemId) {
            navigate(`/dashboard/product/details/${itemId}`);
        } else {
            /* Fallback if item has no id — fall back to listing */
            const q = searchValue.trim();
            navigate(q ? `/dashboard/products?q=${encodeURIComponent(q)}` : '/dashboard/products');
        }
    },
    [navigate, mobileSearch, searchValue]
);

    const handleNavigateToResults = useCallback(
        (q) => {
            const query = (q ?? searchValue).trim();
            if (!query) return;
            navigate(`/dashboard/products?q=${encodeURIComponent(query)}`);
            setIsDropdownOpen(false);
            mobileSearch.onClose();
        },
        [searchValue, navigate, mobileSearch]
    );

    const handleCart = useCallback(() => navigate('/dashboard/cart'), [navigate]);

    /* Active query state — show dropdown only when there's a query AND
       results are either loading or available */
    const showDropdown = isDropdownOpen && searchValue.trim().length > 0;
    const isSearchingActive =
        productsLoading || trimmedDebounced !== searchValue.trim();

    return (
        <>
            <Box
                as="header"
                w="full"
                h={HEADER_HEIGHT}
                bg={SURFACE}
                borderBottom="1px solid"
                borderColor={BORDER}
                px={{ base: '16px', md: '24px' }}
                position="sticky"
                top="0"
                zIndex="docked"
                fontFamily={FONT}
                transform={hideHeader ? 'translateY(-100%)' : 'translateY(0)'}
                transition="transform 0.28s cubic-bezier(.2,.7,.3,1), box-shadow 0.2s ease"
                boxShadow={hideHeader ? 'none' : SHADOW_SM}
                willChange="transform"
            >
                <Flex h="full" align="center" justify="space-between" gap="16px">
                    {/* LEFT — Search (desktop) wrapped in container for dropdown anchoring */}
                    <Box
                        ref={containerRef}
                        flex="1"
                        maxW="480px"
                        display={{ base: 'none', md: 'block' }}
                        position="relative"
                    >
                        <SearchBar
                            value={searchValue}
                            onChange={handleSearchChange}
                            onFocus={handleSearchFocus}
                        />
                        {showDropdown && (
                            <SearchPreviewDropdown
                                query={searchValue.trim()}
                                items={previewItems}
                                isLoading={isSearchingActive}
                                onItemClick={handleProductClick}
                                onSeeAll={() => handleNavigateToResults()}
                                onClose={() => setIsDropdownOpen(false)}
                            />
                        )}
                    </Box>

                    {/* MOBILE LEFT — spacer */}
                    <Box display={{ base: 'block', md: 'none' }} flex="1" />

                    {/* RIGHT — actions */}
                    <HStack spacing={{ base: '4px', md: '6px' }} flexShrink={0}>
                        <Box display={{ base: 'block', md: 'none' }}>
                            <HeaderIconButton
                                ariaLabel="Search"
                                icon={<SearchIcon />}
                                onClick={mobileSearch.onOpen}
                            />
                        </Box>

                        <Box display={{ base: 'none', sm: 'block' }}>
                            <DashCurrencySelector />
                        </Box>

                        <NotificationsMenu navigate={navigate} />

                        <HeaderIconButton
                            ariaLabel={`Cart with ${cartCount} ${cartCount === 1 ? 'item' : 'items'}`}
                            icon={<CartIcon />}
                            onClick={handleCart}
                            badgeContent={cartCount}
                            badgeColor={NAVY}
                        />

                        <Box pl={{ base: '4px', md: '8px' }} ml={{ base: '0', md: '4px' }}
                            borderLeft={{ base: 'none', md: '1px solid' }} borderColor={BORDER}>
                            <UserBadge
                                name={displayName}
                                avatarUrl={avatar}
                                agentId={agentId}
                                setBg={setBg}
                                bg={bg}
                            />
                        </Box>
                    </HStack>
                </Flex>
            </Box>

            {/* Mobile search modal */}
            <MobileSearchModal
                isOpen={mobileSearch.isOpen}
                onClose={mobileSearch.onClose}
                value={searchValue}
                onChange={handleSearchChange}
                onSubmit={handleNavigateToResults}
                items={previewItems}
                isLoading={isSearchingActive}
                onItemClick={handleProductClick}
                onSeeAll={() => handleNavigateToResults()}
            />
        </>
    );
};

export default DashHead;